import styled from 'styled-components';

export const MainInner = styled.div`

  overflow-y: scroll;
  height: 100%;
  overflow-x: hidden;
`;
export const MainBannerWrapper = styled.div`
  margin-bottom: calc(100vw * (32 / 375));
`;